









































































import Component from 'vue-class-component';
import { Mixins, Prop, Watch } from 'vue-property-decorator';
import { TimeRegistration } from '@/core/interfaces/timeRegistration';
import axios from 'axios';
import FormatsDate from '@/components/mixins/FormatsDate';
import TimeRegistrationForm from '@/components/TimeRegistrationForm.vue';
import { Ticket } from '@/core/interfaces/ticket';
import { Notification } from '@/core/interfaces/notification';

@Component({
    components: { TimeRegistrationForm },
})
export default class TimeRegistrations extends Mixins(FormatsDate) {
    @Prop({ type: Object, default: null })
    from!: {ticketId?: number; notificationId?: number} | null;

    @Prop({ type: Boolean })
    locked!: boolean;

    @Prop({ type: Number, required: true })
    vehicleId!: number;

    registrations: TimeRegistration[] = [];
    loading = false;

    newTimeRegistrationStartedAt = '';
    newTimeRegistrationTimeSpentInMinutes = 10;

    @Watch('from', { immediate: true })
    async setInitialDate(): Promise<void> {
        if (!this.from) {
            return;
        }

        if (this.from.notificationId) {
            const notification = await this.fetchNotification(this.from.notificationId);
            this.newTimeRegistrationStartedAt = notification.created_at;
        } else if (this.from.ticketId) {
            const ticket = await this.fetchTicket(this.from.ticketId);
            this.newTimeRegistrationStartedAt = ticket.created_at;
        }
    }

    async fetchTicket(ticketId: number): Promise<Ticket> {
        return await axios
            .get<Ticket>(`/tickets/${ticketId}`)
            .then((response) => response.data);
    }

    async fetchNotification(notificationId: number): Promise<Notification> {
        return await axios
            .get<Notification>(`/notifications/${notificationId}`)
            .then((response) => response.data);
    }

    @Watch('from', { immediate: true, deep: true })
    async fetchTimeRegistrations(): Promise<void> {
        if (this.from) {
            this.registrations = await axios
                .get<TimeRegistration[]>('/time-registrations', {
                    params: {
                        ticketId: this.from.ticketId,
                        notificationId: this.from.notificationId,
                    },
                })
                .then((response) => response.data);
        }
    }

    @Watch('registrations', { immediate: true })
    updateNumberOfRegistrations(): void {
        this.$emit('number-of-registrations-changed', this.registrations.length);
    }

    async addTimeRegistration(
        startedAt: string,
        timeSpentInMinutes: number,
    ): Promise<void> {
        const response = await axios.post<TimeRegistration>(
            '/time-registrations',
            {
                ticket_id: this.from?.ticketId,
                notification_id: this.from?.notificationId,
                vehicle_id: this.vehicleId,
                type: 'customer',
                started_at: startedAt,
                time_spent_in_minutes: timeSpentInMinutes,
            },
        );
        this.registrations.push(response.data);
    }

    async deleteRegistration(id: number): Promise<void> {
        this.loading = true;
        try {
            await axios.delete(`/time-registrations/${id}`);
            this.registrations = this.registrations.filter(
                (reg) => reg.id !== id,
            );
        } finally {
            this.loading = false;
        }
    }

    get total(): number {
        return this.registrations.reduce(
            (sum, reg) => sum + reg.time_spent_in_minutes,
            0,
        );
    }

    get registrationsSorted(): TimeRegistration[] {
        return this.registrations.slice().sort((a, b) => {
            return (
                new Date(b.started_at).getTime() -
                new Date(a.started_at).getTime()
            );
        });
    }
}
